import React from 'react';
import { useSelector } from 'react-redux';

import useEffectOnce from 'hooks/useEffectOnce';
import type { InfluencerContent } from 'types/influencer';
import Carousel from 'components/common/Carousel/Carousel';
import InlineBrandInfluencerShoppablePostCard from 'components/influencer/shoppablePosts/InlineBrandInfluencerShoppablePostCard';
import { getAmethystPageType } from 'helpers/analytics';
import { BrandShopTheLookPlacementType } from 'constants/amethystEnums';
import { track } from 'apis/amethyst';
import { evBrandShopTheLookImpression } from 'events/influencerShoppablePost';
import { transformContentForAmethystEvent } from 'helpers/ShoppablePostUtils';
import type { AppState } from 'types/app';

import css from 'styles/components/influencer/shoppablePosts/brandInfluencerShoppablePostsCarousel.scss';

interface BrandInfluencerShoppablePostsCarouselProps {
  contents: InfluencerContent[];
}

export const BrandInfluencerShoppablePostsCarousel = ({ contents }: BrandInfluencerShoppablePostsCarouselProps) => {
  const pageType = useSelector((state: AppState) => state.pageView.pageType);
  const sourcePage = getAmethystPageType(pageType);

  useEffectOnce(() => {
    const contentData = contents.map((content, index) => transformContentForAmethystEvent(content, index + 1));
    track(() => [
      evBrandShopTheLookImpression,
      {
        placementType: BrandShopTheLookPlacementType.CAROUSEL,
        contents: contentData,
        sourcePage
      }
    ]);
  });

  const shoppablePosts = contents.map((content, index) => (
    <InlineBrandInfluencerShoppablePostCard
      key={`shopTheLook-${content.contentId}`}
      content={content}
      cardIndex={index}
      isRenderedOnCarousel={true}
      sourcePage={sourcePage}
    />
  ));

  return (
    <div className={css.carouselWrapper}>
      <Carousel header={{ title: 'Shop Our Stylist Picks Below' }} slides={shoppablePosts} />
    </div>
  );
};

export default BrandInfluencerShoppablePostsCarousel;
